import script from "./ChatContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ChatContainer.vue?vue&type=style&index=0&id=f21e5e86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f21e5e86"]])

export default __exports__